import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconsModule } from '@progress/kendo-angular-icons';
import { FormFieldModule, InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { TypographyModule } from '@progress/kendo-angular-typography';
import { CustomActionsComponent } from './custom-actions.component';
import { MenuModule } from '@progress/kendo-angular-menu';
import { DialogModule } from '@progress/kendo-angular-dialog';

@NgModule({
  declarations: [CustomActionsComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    IconsModule,
    FormFieldModule,
    LabelModule,
    InputsModule,
    ReactiveFormsModule,
    ButtonsModule,
    DropDownListModule,
    TypographyModule,
    MenuModule,
    DialogModule,
  ],
  exports: [CustomActionsComponent],
})
export class CustomActionsModule {}
